import CommonState from './CommonState'
/**
 * 操作符常量定义
 */
export const OPERATOR_EQUAL = new CommonState('=', '等于', 'Equal')
export const OPERATOR_UNEQUAL = new CommonState('!=', '不等于', 'Unequal')
export const OPERATOR_GREATER = new CommonState('>=', '大于', 'Greater')
export const OPERATOR_LESS = new CommonState('<=', '小于', 'Less')
export const OPERATOR_LIKE = new CommonState('LIKE', '包含', 'Like')
export const OPERATOR_IN = new CommonState('IN', '包含', 'In')
export const OPERATOR_NOT_IN = new CommonState('NOT IN', '不包含', 'Not In')
export const OPERATOR_IS_NOT_NULL = new CommonState('IS NOT NULL', '不为空', 'Is Not Null')
export const OPERATOR_IS_NULL = new CommonState('IS NULL', '为空', 'Is Null')
export const OPERATOR_RANGE = new CommonState('RANGE', '范围', 'Range')
export const OPERATOR_BATCH = new CommonState('BATCH', '批量', 'Batch')
export const OPERATOR_BATCH_EXCLUDE = new CommonState('BATCH_EXCLUDE', '批量排除', 'Batch Exclude')
// Regex match (backend support required).
// UI treats it like a batch input and joins multiple lines with '|'.
export const OPERATOR_REGEXP = new CommonState('REGEXP', '批量模糊', 'Regexp')

export default {
  OPERATOR_EQUAL,
  OPERATOR_UNEQUAL,
  OPERATOR_GREATER,
  OPERATOR_LESS,
  OPERATOR_LIKE,
  OPERATOR_IN,
  OPERATOR_NOT_IN,
  OPERATOR_IS_NOT_NULL,
  OPERATOR_IS_NULL,
  OPERATOR_RANGE,
  OPERATOR_BATCH,
  OPERATOR_BATCH_EXCLUDE,
  OPERATOR_REGEXP
}
